export const changeSummaryItemColor = (item_code) => {
  const id_assembly = "box-cart-item-pcbassembly";
  const id_parts = "box-cart-item-pcbparts";
  const id_fabrication = "box-cart-item-pcbfabrication";

  switch (item_code) {
    case 'pcbassembly':
      addRemoveStyleCartSumary(id_assembly,id_parts,id_fabrication)
      break;
    case 'pcbparts':
      addRemoveStyleCartSumary(id_parts,id_assembly,id_fabrication)
      break;
    case 'pcbfabrication':
      addRemoveStyleCartSumary(id_fabrication,id_assembly,id_parts)
      break;
    default:
      break;
  }
}